import React, { Component } from "react";
import {
  Col,
  Container,
  FormControl,
  InputGroup,
  Row,
  Dropdown,
} from "react-bootstrap";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { setToken } from "../helpers";

import Global from "../Global.json";

import * as lanuageActions from "../redux/actions/language";
import * as userActions from "../redux/actions/user";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import swal from "sweetalert";
import { FaGoogle, FaFacebookF } from "react-icons/fa";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginForm: 2,
      Password: "",
      email: "",
      regEmail: "",
      phone: "",
      regPassword: "",
      countries: [],
      countryCode: "+1",
    };
  }

  componentDidMount() {
    this.getCountries();
  }

  /** get Countries Web */
  getCountries() {
    fetch("/c.json", {
      method: "GET",
      headers: {
        // Accept: "application/json",
        // "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((result) => {
        function compare(a, b) {
          if (a.dialling_code < b.dialling_code) {
            return -1;
          }
          if (a.dialling_code > b.dialling_code) {
            return 1;
          }
          return 0;
        }

        this.setState({
          countries: result.countryCodes
            .sort(compare)
            .filter(
              (v, i, a) =>
                a.findIndex((t) => t.dialling_code === v.dialling_code) === i
            ),
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }
  /** get Countries Web End */

  render() {

    function GoogleIconButton({ onProfile }) {
      const login = useGoogleLogin({
        scope: 'openid email profile',
        onSuccess: async (token) => {
          const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
            headers: { Authorization: `Bearer ${token.access_token}` },
          });
          onProfile(await res.json());
        },
        onError: () => console.log('Google Login Failed'),
      });
      return (
        <button className="googleLogin" onClick={() => login()}>
          <FaGoogle size={18}/>
        </button>
      );
    }    

    function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
    return (
      <div className="loginPage">
        <Container>
          <Row>
            <Col lg={6}>
              <div className="login_form">
                {/* img backgraound  form start  */}
                <img src="/img/page.png" alt="k" className="form_bg" />
                {/* img backgraound  form end  */}
                {/* form tabs section start  */}
                <div className="loginTabs">
                  <Row className="no-margin">
                    <Col xs={6} className="no-padd">
                      <span
                        className={
                          this.state.loginForm == 1 ? "loginSelected" : ""
                        }
                        onClick={() => {
                          window.location.href = "/login";
                        }}
                      >
                        تسجيل دخول
                      </span>
                    </Col>
                    <Col xs={6} className="no-padd">
                      <span
                        className={
                          this.state.loginForm == 2 ? "loginSelected" : ""
                        }
                        onClick={() => {
                          window.location.href = "/register";
                        }}
                      >
                        تسجيل
                      </span>
                    </Col>
                  </Row>
                </div>
                {/* form tabs section end  */}

                {/* form  section start  */}

                <div className="formInputs">
                  <div className="">
                    <Row className="">
                      <Col sm={6}>
                        <input
                          className={
                            this.state.firstNameEmpty ? "border_red" : ""
                          }
                          type="text"
                          placeholder={this.props.i18n.firstName}
                          onChange={(e) => {
                            this.setState({
                              firstName: e.target.value,
                              firstNameEmpty: false,
                            });
                          }}
                        />
                      </Col>
                      <Col sm={6}>
                        <input
                          className={
                            this.state.lastNameEmpty ? "border_red" : ""
                          }
                          type="text"
                          placeholder={this.props.i18n.lastName}
                          onChange={(e) => {
                            this.setState({
                              lastName: e.target.value,
                              lastNameEmpty: false,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                  <input
                    type="text"
                    placeholder={this.props.i18n.email}
                    className={this.state.regEmailEmpty ? "border_red" : ""}
                    onChange={(e) => {
                      this.setState(
                        {
                          regEmail: e.target.value,
                          regEmailEmpty: false,
                        },
                        () => {
                          this.emailValidate();
                        }
                      );
                    }}
                    value={this.state.regEmail.trim()}
                  />
                  {this.state.emailError && this.state.regEmail != "" ? (
                    <span className="note-pass">الايميل غير صحيح</span>
                  ) : null}

                  {/* phone input start */}
                  {/* <input
                    type="text"
                    maxLength={10}
                    className={this.state.phoneEmpty ? "border_red" : ""}
                    placeholder={this.props.i18n.phone}
                    onChange={(e) => {
                      if (
                        isNumber(e.target.value) ||
                        e.target.value.length == 0
                      ) {
                        this.setState({
                          phone: e.target.value,
                          phoneEmpty: false,
                        });
                      }
                    }}
                    value={this.state.phone.trim()}
                  />
             */}

                  <InputGroup
                    className={this.state.phoneEmpty ? "border_red" : ""}
                  >
                    <FormControl
                      maxLength={14}
                      placeholder={this.props.i18n.phone}
                      onChange={(e) => {
                        if (
                          isNumber(e.target.value) ||
                          e.target.value.length == 0
                        ) {
                          this.setState({
                            phone: e.target.value,
                            phoneEmpty: false,
                          });
                        }
                      }}
                      value={this.state.phone.trim()}
                    />
                    <InputGroup.Append>
                      <select
                        onChange={(e) => {
                          this.setState({
                            countryCode: e.target.value,
                          });
                        }}
                      >
                        {this.state.countries.map((item, index) => {
                          return (
                            <option value={item.dialling_code} key={index}>
                              {item.dialling_code}
                            </option>
                          );
                        })}
                      </select>{" "}
                    </InputGroup.Append>
                  </InputGroup>

                  {this.state.phone.length > 14 ? (
                    <span className="note-pass">
                      يجب ان لا يكون الرقم اكثر من 10 خانات
                    </span>
                  ) : null}
                  {/* phone input end  */}

                  <InputGroup
                    className={
                      this.state.regPasswordEmpty ? "border_red mb-3" : "mb-3"
                    }
                  >
                    <FormControl
                      type={this.state.showPass ? "text" : "password"}
                      aria-describedby="basic-addon1"
                      placeholder={this.props.i18n.password}
                      onChange={(e) => {
                        this.setState({
                          regPassword: e.target.value,
                          regPasswordEmpty: false,
                        });
                      }}
                      value={this.state.regPassword.trim()}
                    />
                    <InputGroup.Append>
                      {this.state.showPass ? (
                        <img
                          src="/img/Group 731.png"
                          className="reg-inp-img"
                          onClick={() =>
                            this.setState({
                              showPass: !this.state.showPass,
                            })
                          }
                        />
                      ) : (
                        <img
                          src="/img/eye_close@noon.png"
                          className="pass-view"
                          onClick={() =>
                            this.setState({
                              showPass: !this.state.showPass,
                            })
                          }
                        />
                      )}
                    </InputGroup.Append>
                  </InputGroup>
                  {this.state.regPassword.length < 6 &&
                  this.state.regPassword != "" ? (
                    <span className="note-pass">
                      {this.props.i18n.mustBeMore6}
                    </span>
                  ) : null}
                </div>
                {/* form  section end  */}

                {/* social buttons  section start  */}
                <div className="socilaLogin_buttons">
                  <Row className="no-margin">
                    <Col xs={6} className="no-padd">
                      <div className="socilaLogin">
                        <p>تسجيل عن طريق </p>
                      {/*   <FacebookLogin
                          appId="3487964654610027"
                          scope="public_profile,email"
                          getProfile={true}
                          onSuccess={(res) => {
                            // res يحتوي accessToken و userID، ومع getProfile=true بيصير عندك profile فيه الاسم والإيميل والصورة
                            const facebook_id = res.userID;
                            const name =
                              res.name || res.profile?.name || "Facebook User";
                            const email = res.email || res.profile?.email || "";
                            const image =
                              res.picture?.data?.url ||
                              res.profile?.picture?.data?.url ||
                              "";

                            fetch(`${Global.api_link}facebookLogin`, {
                              method: "POST",
                              headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                              },
                              body: JSON.stringify({
                                facebook_id,
                                name,
                                email,
                                social_image: image,
                              }),
                            })
                              .then((r) => r.json())
                              .then(async (result) => {
                                if (!result.access_token)
                                  throw new Error("Facebook login failed");
                                setToken(result.access_token);
                                let { actions } = this.props;
                                await actions.setUser({
                                  ...this.props.user,
                                  UID: result.user?.id,
                                  userName: result.user?.name,
                                  userEmail: result.user?.email,
                                  userImage: image,
                                });
                                window.location.href = "/";
                              })
                              .catch(console.error);
                          }}
                          onFail={(error) => console.error(error)}
                          render={(renderProps) => (
                            <button
                              className="facbookLogin"
                              onClick={renderProps.onClick}
                            >
                              <FaFacebookF size={18} />
                            </button>
                          )}
                        />
                        */}
                        <GoogleOAuthProvider clientId="233832999807-pcv295f9mmj0k2c9addbpdi4dakdno9r.apps.googleusercontent.com">
                          <GoogleIconButton
                            onProfile={(payload) => {
                              const google_id = payload.sub;
                              const name =
                                payload.name ||
                                `${payload.given_name ?? ""} ${
                                  payload.family_name ?? ""
                                }`.trim();
                              const email = payload.email || "";
                              const image = payload.picture || "";

                              fetch(`${Global.api_link}googleLogin`, {
                                method: "POST",
                                headers: {
                                  Accept: "application/json",
                                  "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                  google_id,
                                  name: name || "Google User",
                                  email,
                                  social_image: image,
                                }),
                              })
                                .then((r) => r.json())
                                .then(async (result) => {
                                  if (!result.access_token)
                                    throw new Error("Google login failed");
                                  setToken(result.access_token);
                                  const { actions } = this.props;
                                  await actions.setUser({
                                    ...this.props.user,
                                    UID: result.user?.id,
                                    userName: result.user?.name,
                                    userEmail: result.user?.email,
                                    socialImage: image,
                                  });
                                  window.location.href = "/";
                                })
                                .catch(console.error);
                            }}
                          />
                        </GoogleOAuthProvider>
                      </div>
                    </Col>
                    <Col xs={6} className="no-padd margin-top-auto">
                      {/* {this.state.loginForm == 1 ? ( */}
                      {this.state.submitLoader ? (
                        <div className="loginLoader">
                          <div className="lds-ring">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="mainButton"
                          onClick={() => {
                            this.register();
                          }}
                        >
                          {/* submit button start  */}
                          <div></div> انشاء الحساب
                          {/* submit button end  */}
                        </div>
                      )}
                      {/* // ) : (
                      //   <div className="mainButton">
                      //     <div></div> انشاء الحساب
                      //   </div>
                      // )} */}
                    </Col>
                  </Row>
                </div>
                {/* social buttons  section end  */}
              </div>
            </Col>

            {/* main login img start  */}
            <Col md={6} className="margin-top-auto d_none_under992">
              <div className="loginMainImg">
                <img src="/img/Group 1052.png" alt="l" />
              </div>
            </Col>
            {/* main login img end  */}
          </Row>
        </Container>
      </div>
    );
  }

  //  register api  start
  register() {
    if (
      this.state.regEmail == "" ||
      this.state.regEmail == null ||
      this.state.firstName == "" ||
      this.state.firstName == null ||
      this.state.lastName == "" ||
      this.state.lastName == null ||
      this.state.phone == "" ||
      this.state.phone == null ||
      this.state.regPassword == "" ||
      this.state.regPassword == null ||
      this.state.emailError ||
      this.state.regPassword.length < 6
    ) {
      if (this.state.regEmail == "" || this.state.regEmail == null) {
        this.setState({
          regEmailEmpty: true,
        });
      }
      if (this.state.regPassword == "" || this.state.regPassword == null) {
        this.setState({
          regPasswordEmpty: true,
        });
      }
      if (this.state.phone == "" || this.state.phone == null) {
        this.setState({
          phoneEmpty: true,
        });
      }
      if (this.state.firstName == "" || this.state.firstName == null) {
        this.setState({
          firstNameEmpty: true,
        });
      }
      if (this.state.lastName == "" || this.state.lastName == null) {
        this.setState({
          lastNameEmpty: true,
        });
      }
    } else {
      this.setState(
        {
          submitLoader: true,
        },
        () => {
          fetch(Global.api_link + "userSignup", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: this.state.regEmail,
              password: this.state.regPassword,
              name: this.state.firstName + " " + this.state.lastName,
              phone: this.state.countryCode + this.state.phone,
              device_id: (crypto?.randomUUID?.() || String(Math.random()))
            }),
          })
            .then((response) => response.json())
            .then(async (result) => {
              this.setState(
                {
                  submitLoader: false,
                },
                async () => {
                  if (result.status == 2) {
                    swal({
                      title: this.props.i18n.sorry,
                      text: "البريد الالكتروني مستخدم من قبل",
                      icon: "warning",
                      button: {
                        text: this.props.i18n.ok,
                      },
                      // className: "addAccountSwal",
                    });
                  } else if (result.status == 0) {
                    swal({
                      title: this.props.i18n.sorry,
                      text: result.error,
                      icon: "warning",
                      button: {
                        text: this.props.i18n.ok,
                      },
                      // className: "addAccountSwal",
                    });
                  } else {
                    let { actions } = this.props;
                    setToken(result.access_token);
                    console.log("token",result.access_token);
                    await actions.setUser({
                      ...this.props.user,
                      UID: result.user?.id,
                      userName: result.user?.name,
                      userEmail: result.user?.email,
                      userPhone: result.user?.phone,
                      userImage: result.user?.image ?? '',
                      socialImage: result.user?.social_image ?? '',
                    });

                    window.location.href = "/";
                  }
                }
              );
            })
            .catch((error) => {
              console.error(error);
            });
        }
      );
    }
  }
  //  register api  end

  //// email validation function
  validateEmailRegular(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  emailValidate() {
    var value = this.state.regEmail;
    if (!this.validateEmailRegular(value)) {
      this.setState({
        emailError: true,
        emailValidate: value + this.props.i18n.notValidEmail,
      });
    } else {
      this.setState({
        emailError: false,
        // emailValidate: this.props.i18n.insertEmail,
      });
    }
  }
  //// end email validation function
}

const mapStateToProps = (state) => ({
  language: state.language.lang,
  // i18n: state.language.lang === "en" ? Global.en : Global.ar,
  i18n: Global.ar,
  user: state.userData.user,
});
const ActionCreators = Object.assign({}, lanuageActions, userActions);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(ActionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
